import { getVariantStyles } from '@belong/ui-components/components/actions/Button';
import styled from 'styled-components';

export const AttachmentErrorWrapper = styled.div`
  margin-bottom: 16px;
`;

// We can't a button because it strips out `blob:` from the start
export const AttachmentLink = styled.a`
  ${(): any => getVariantStyles({ variant: 'quaternary' })}
`;
